<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="320px"
    top="20%"
    class="confirm-dialog"
    append-to-body
    destroy-on-closes
    :show-close="false"
    v-on="$listeners"
  >
    <p v-if="title" class="font-black mb-2">{{ title }}</p>
    <pre class="whitespace-pre-wrap">{{ content }}</pre>
    <slot name="action">
      <div class="text-right">
        <el-button class="confirm-dialog__btn confirm-dialog__btn--shadow" @click="onAccept">{{
          $t('common.label.yes')
        }}</el-button>
        <el-button class="confirm-dialog__btn" @click="onCancel">{{ $t('common.label.no') }}</el-button>
      </div>
    </slot>
  </el-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    visible: Boolean,
    content: {
      type: String,
      default: () => '',
    },
    title: {
      type: String,
      default: () => '',
    },
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },
  },
  methods: {
    onCancel() {
      this.dialogVisible = false
    },
    onAccept() {
      this.$emit('on-accept')
      this.dialogVisible = false
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/css/components/confirm-dialog.scss';
</style>
